import {
  EMPLOYEE_DEFAULT_ROLE_ITEM,
  RESIDENT_DEFAULT_ROLE_ITEM,
} from '../constants/lixani-default-project-roles';

export const returnDefaultPermissionsByEmploymentType = (projectResources) => {
  const foundEmployeeResource = projectResources.some(
    (resource) =>
      !resource.employmentType || resource.employmentType === 'EMPLOYEE'
  );

  const resourceDefaultPermissions = foundEmployeeResource
    ? EMPLOYEE_DEFAULT_ROLE_ITEM.permissions
    : RESIDENT_DEFAULT_ROLE_ITEM.permissions;

  return resourceDefaultPermissions;
};
